<template>
    <div id="category">
        <nav-bar class="nav-bar" @click="sdf"><div slot="center">分类</div></nav-bar>

        <div class="main-content">
            <tab-menu class="menu" :categories="categories" @selectItem="selectItem"></tab-menu>
            <div class="detail-content">
                <tab-control class="fixed" :titles="['流行','精选','新款']" @tabClick="tabClick"
                             ref="topTabControl" v-show="isTabFixed"></tab-control>
                <Scroll id="tab-content" class="wrapper" ref="scroll"
                        :probe-type="3"
                        @scroll="contentScroll"
                        :pull-up-load="true">
                    <tab-content-category @categoryImgLoad="categoryImgLoad" :subcategories="showSubcategory"></tab-content-category>
                    <tab-control  :titles="['流行','精选','新款']" @tabClick="tabClick"
                                  ref="tabControl"></tab-control>
                    <tab-conten-detail :category-detail="showCategoryDetail"></tab-conten-detail>
                </scroll>
            </div>
        </div>

    </div>
</template>

<script>
    import Scroll from "../../components/common/scroll/Scroll";
    import NavBar from "../../components/common/navbar/NavBar";
    import tabControl from "../../components/content/tabControl/tabControl";
    import TabMenu from "./childComps/TabMenu";

    import {POP,SELL,NEW} from "../../components/common/const";

    import TabContentCategory from "./childComps/TabContentCategory";
    import TabContenDetail from "./childComps/TabContenDetail";

    import {getCategory, getSubcategory, getCategoryDetail} from "../../components/network/category";
    import {goodsitemImageLoadRefresh, tabControlMixin} from "../../components/common/mixin";







    export default {
        name: "MallCategory",
        components: {
            TabContentCategory,
            NavBar,
            Scroll,
            TabMenu,
            TabContenDetail,
            tabControl,
        },
        mixins:[goodsitemImageLoadRefresh,tabControlMixin],
        data(){
            return{
                categories: [],
                categoryData: [],
                currentIndex: -1,
                currentType: 'pop',
            }
        },
        mounted() {
            // this.scroll=new BScroll(document.querySelector('.wrapper'),{

            // })
            this._getCategory();

        },
        activated(){
            this.$refs.scroll.scroll.refresh();
        },
        computed: {
            showSubcategory() {
                if (this.currentIndex === -1) return {}
                return this.categoryData[this.currentIndex].subcategories
            },
            showCategoryDetail() {
                if (this.currentIndex === -1) return []

                return this.categoryData[this.currentIndex].categoryDetail[this.currentType]
            }
        },
        methods:{
            sdf(){
                // this.$refs.scroll.scroll.refresh();
                console.log('----')
            },
            _getCategory(){
                getCategory().then(res=>{
                    this.categories=res.data.category.list;
                    // console.log(this.categories);
                    for (let i = 0; i < this.categories.length; i++) {
                        this.categoryData[i] = {
                            subcategories: {},
                            categoryDetail: {
                                'pop': [],
                                'new': [],
                                'sell': []
                            }
                        }
                    }
                    this._getSubcategories(0)
                })
            },
            _getSubcategories(index) {
                this.currentIndex = index;
                const mailKey = this.categories[index].maitKey;
                getSubcategory(mailKey).then(res => {
                    this.categoryData[index].subcategories = res.data;
                    this.categoryData = {...this.categoryData};
                    this._getCategoryDetail(POP);
                    this._getCategoryDetail(SELL);
                    this._getCategoryDetail(NEW);
                })
            },
            _getCategoryDetail(type) {
                // 1.获取请求的miniWallkey
                const miniWallkey = this.categories[this.currentIndex].miniWallkey;
                // console.log(miniWallkey)
                // 2.发送请求,传入miniWallkey和type
                getCategoryDetail(miniWallkey, type).then(res => {
                    // 3.将获取的数据保存下来
                    this.categoryData[this.currentIndex].categoryDetail[type] = res
                    this.categoryData = {...this.categoryData}
                    // console.log(res)
                    // console.log(this.categoryData[this.currentIndex].categoryDetail[POP])
                })
            },
            // tabClick(index) {
            //     switch (index) {
            //         case 0:
            //             this.currentType = POP
            //             break
            //         case 1:
            //             this.currentType = NEW
            //             break
            //         case 2:
            //             this.currentType = SELL
            //             break
            //     }
            // },
            selectItem(index){
                this._getSubcategories(index)
            },
            contentScroll(position){
                // this.isShowBackTop= (-position.y) >1000;
                // this.showTabControl()
                this.isTabFixed=position.y<(-this.tabOffsetTop);
                // console.log(this.tabOffsetTop)
            },
            categoryImgLoad(){
                this.TabControlPosition();
            }
        }
    }
</script>

<style scoped>
    #category{
        height: 100vh;

    }
    .nav-bar{
        background-color: var(--color-tint);
        font-weight:700;
        color:#fff;
    }
    .wrapper{
        position: relative;
        height: calc(100% - 10px);
        flex: 1;
        /*height: 580px;*/
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
    }
    .main-content {
        position:absolute;
        left: 0;
        right: 0;
        top: 44px;
        bottom: 49px;

        display: flex;
    }
    /*#tab-content {*/
    /*    height: 100%;*/
    /*    flex: 1;*/
    /*}*/
    .detail-content{
        position: relative;
        display: flex;
        flex: 1;
        width: 100%;
        /*background-color: red;*/
    }
    .menu{
        /*position: absolute;*/
        /*flex: 1;*/
    }
    .fixed {
        position: absolute;
        width: 100%;
        top: 0px;
        left: 0px;
        right: 0;
        z-index: 9;
    }
</style>